import React, { Fragment, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { TableSectionV2 } from 'components/UI';
import localization from 'assets/localization/localization';
import { BaseUrl } from '../../../contexts/baseUrl/baseUrl';
import Layout from '../../../components/sales/layout/layout';
import moment from 'moment';
import Images from '../../../assets/images/imageData';
import { Link } from 'react-router-dom';
import { formatReconStatus } from '../shared/reconStatus';

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const Listing = ({ userRequestList, requestList = [] }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await userRequestList();
      setIsLoading(false);
    })();
  }, []);

  const buildRowActions = useCallback(
    (row) => [
      {
        name: 'View',
        link: `${baseUrl}/request-view/${row.id}`,
      },
    ],
    [baseUrl]
  );

  const tableColumns = useMemo(
    () => [
      { key: 'request_id', label: 'Request Id', format: (val) => cell(val) },
      {
        key: 'requested_date',
        label: 'Requested Date',
        format: (val) => {
          if (!val) return '—';
          const formatted = moment(val).format('DD-MMMM-YYYY');
          return formatted === 'Invalid date' ? '—' : formatted;
        },
      },
      { key: 'use_case_name', label: 'Finance use case', format: (val) => cell(val) },
      { key: 'a1_approval_name', label: 'Approver L1', format: (val) => cell(val) },
      { key: 'a2_approval_name', label: 'Approver L2', format: (val) => cell(val) },
      { key: 'PI_no', label: 'PI', format: (val) => cell(val) },
      { key: 'TI_no', label: 'TI', format: (val) => cell(val) },
      { key: 'status', label: 'Request Status', format: (val) => cell(val) },
      { key: 'finance_approval_name', label: 'Finance acted by', format: (val) => cell(val) },
      {
        key: 'recon_status',
        label: 'Conversion Status',
        format: (val, row) => formatReconStatus(val, row),
      },
      {
        key: 'actions',
        label: 'Actions',
        getActions: (row) => buildRowActions(row),
      },
    ],
    [buildRowActions]
  );

  const onPageChange = async (val) => {
    setIsLoading(true);
    await userRequestList(val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      requestList &&
      requestList !== [] &&
      requestList?.data !== undefined &&
      requestList?.data &&
      requestList?.data.length > 0
    ) {
      setListData(requestList.data);
      setPageCount(Math.ceil(requestList.total / requestList.per_page));
      requestList.current_page && setCurrentPage(requestList.current_page);
    } else if (requestList?.data !== undefined) {
      setListData([]);
      setPageCount(0);
    }
  }, [requestList]);

  const srNo =
    requestList?.from ??
    (requestList?.current_page && requestList?.per_page
      ? (requestList.current_page - 1) * requestList.per_page + 1
      : 1);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link to={`${baseUrl}/user-request`} className="btn btn-primary d-none d-md-inline-block">
          {localization.userRequest}
          <img src={Images?.ArrowRight} alt=""></img>
        </Link>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.userRequest}
      isLoading={isLoading}
      isGoback={true}
      useNewHeaderLayout
      Buttons={headerBtns}
    >
      <TableSectionV2
        hideHeader
        hideTitleAndStatusFilter
        className="site-dashboard-table-section"
        tableData={listData}
        tableColumns={tableColumns}
        tableSectionProps={{ srNo }}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        isLoading={isLoading}
        emptyMessage="No requests found."
      />
    </Layout>
  );
};

export default Listing;
